import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';

// import { LoginComponent } from './login.component';
import { IeeeLoginComponent } from './ieee-login/ieee-login.component';
import { IopLoginComponent } from './iop-login/iop-login.component';
import { LibServLoginComponent } from './lib-serv-login/lib-serv-login.component';
import { WtcoxLoginComponent } from './wtcox-login/wtcox-login.component';
import { GenericLoginComponent } from './generic-login/generic-login.component';
import { SmaterialsLoginComponent } from './smaterials-login/smaterials-login.component';
import { SimageLoginComponent } from './simage-login/simage-login.component';
import { SprotocolsLoginComponent } from './sprotocols-login/sprotocols-login.component';
import { IopScienceLoginComponent } from './iop-science-login/iop-science-login.component';
import { LoginGuard } from './login.guard';

import { IeeecsLoginComponent } from './ieeecs-login/ieeecs-login.component';
import { RscLoginComponent } from './rsc-login/rsc-login.component';
import { RcniLoginComponent } from './rcni-login/rcni-login.component';
import { HcnLoginComponent } from './hcn-login/hcn-login.component';
import { IjcLoginComponent } from './ijc-login/ijc-login.component';
import { TglLoginComponent } from './tgl-login/tgl-login.component';
import { NpgLoginComponent } from './npg-login/npg-login.component';
import { PalLoginComponent } from './pal-login/pal-login.component';
import { PalconnectLoginComponent } from './palconnect-login/palconnect-login.component';
import { AstmLoginComponent } from './astm-login/astm-login.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { SecurityCheckForgotpassComponent } from './security-check-forgotpass/security-check-forgotpass.component';
import { DemoLoginComponent } from './demo-login/demo-login.component';

import { AuthGuard } from './../auth.guard';
import { HomeIndexComponent } from './home-index/home-index.component';
import { MmsLoginComponent } from './mms-login/mms-login.component';
export const routes: Routes = [
    {
        path: '',
        component: HomeIndexComponent,
        // redirectTo: 'ieee/login',
        pathMatch: 'full',
        canActivate: [LoginGuard]
    },
    {
        path: 'ieee',
        redirectTo: 'ieee/login',
        canActivate: [LoginGuard]
    },
    {
        path: 'ieee/login',
        component: IeeeLoginComponent,
        canActivate: [LoginGuard]
    },
    // {
    //     path: 'iop',
    //     redirectTo: 'iop/login',
    //     canActivate: [LoginGuard]
    // },
    // {
    //     path: 'iop/login',
    //     component: IopLoginComponent,
    //     canActivate: [LoginGuard]
    // },
    {
        path: 'lib-serv',
        redirectTo: 'lib-serv/login',
        canActivate: [LoginGuard]
    },
    {
        path: 'lib-serv/login',
        component: LibServLoginComponent,
        canActivate: [LoginGuard]
    },
    {
        path: 'wtcox',
        redirectTo: 'wtcox/login',
        canActivate: [LoginGuard]
    },
    {
        path: 'wtcox/login',
        component: WtcoxLoginComponent,
        canActivate: [LoginGuard]
    },
    {
        path: 'iopscience',
        redirectTo: 'iopscience/login',
        canActivate: [LoginGuard]
    },
    {
        path: 'iopscience/login',
        component: IopScienceLoginComponent,
        canActivate: [LoginGuard]
    },
    {
        path: 'smaterial',
        redirectTo: 'smaterial/login',
        canActivate: [LoginGuard]
    },
    {
        path: 'smaterial/login',
        component: SmaterialsLoginComponent,
        canActivate: [LoginGuard]
    },
    {
        path: 'simage',
        redirectTo: 'simage/login',
        canActivate: [LoginGuard]
    },
    {
        path: 'simage/login',
        component: SimageLoginComponent,
        canActivate: [LoginGuard]
    },
    {
        path: 'sprotocol',
        redirectTo: 'sprotocol/login',
        canActivate: [LoginGuard]
    },
    {
        path: 'sprotocol/login',
        component: SprotocolsLoginComponent,
        canActivate: [LoginGuard]
    },
    {
        path: 'generic',
        redirectTo: 'generic/login',
        canActivate: [LoginGuard]
    },
    {
        path: 'generic/login',
        component: GenericLoginComponent,
        canActivate: [LoginGuard]
    },
    {
        path: 'insight/login',
        canActivate: [LoginGuard],
        component: DemoLoginComponent,
    },
    {
        path: 'insight',
        redirectTo: 'insight/login',
        canActivate: [LoginGuard]
    },
    {
        path: 'ieeecs',
        redirectTo: 'ieeecs/login',
        canActivate: [LoginGuard]
    },
    {
        path: 'npg',
        redirectTo: 'npg/login',
        canActivate: [LoginGuard]
    },
    {
        path: 'rsc',
        redirectTo: 'rsc/login',
        canActivate: [LoginGuard]
    },
    {
        path: 'mms',
        redirectTo: 'mms/login',
        canActivate: [LoginGuard]
    },

    {
        path: 'rcni',
        redirectTo: 'rcni/login',
        canActivate: [LoginGuard]
    },
    {
        path: 'hcn',
        redirectTo: 'hcn/login',
        canActivate: [LoginGuard]
    },

    {
        path: 'ijc',
        redirectTo: 'ijc/login',
        canActivate: [LoginGuard]
    },
    {
        path: 'tgl',
        redirectTo: 'tgl/login',
        canActivate: [LoginGuard]
    },
    {
        path: 'pal',
        redirectTo: 'pal/login',
        canActivate: [LoginGuard]
    },
    {
        path: 'palconnect',
        redirectTo: 'palconnect/login',
        canActivate: [LoginGuard]
    },
    {
        path: 'astm',
        redirectTo: 'astm/login',
        canActivate: [LoginGuard]
    },
    {
        path: 'ieeecs/login',
        canActivate: [LoginGuard],
        component: IeeecsLoginComponent
    },
    {
        path: 'npg/login',
        canActivate: [LoginGuard],
        component: NpgLoginComponent
    },
    {
        path: 'rsc/login',
        canActivate: [LoginGuard],
        component: RscLoginComponent
    },
    {
        path: 'mms/login',
        canActivate: [LoginGuard],
        component: MmsLoginComponent
    },
    {
        path: 'rcni/login',
        canActivate: [LoginGuard],
        component: RcniLoginComponent
    },
    {
        path: 'hcn/login',
        canActivate: [LoginGuard],
        component: HcnLoginComponent
    },
    {
        path: 'ijc/login',
        canActivate: [LoginGuard],
        component: IjcLoginComponent
    },
    {
        path: 'tgl/login',
        canActivate: [LoginGuard],
        component: TglLoginComponent
    }, {
        path: 'pal/login',
        canActivate: [LoginGuard],
        component: PalLoginComponent
    }, {
        path: 'palconnect/login',
        canActivate: [LoginGuard],
        component: PalconnectLoginComponent
    }, {
        path: 'astm/login',
        canActivate: [LoginGuard],
        component: AstmLoginComponent
    }, {
        path: 'forgetPassword',
        canActivate: [LoginGuard],
        component: ForgetPasswordComponent
    },
    {
        path: 'securityCheckForgotpassComponent',
        component: SecurityCheckForgotpassComponent
    }
];


export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// ./src/app/pages/login/login.routing.ts